export default "__VITE_ASSET__DkYUq5EN__"